import { WithChildren } from '../../types/utility';
import { useEffect, useRef } from 'react';

interface TimeoutableProps extends WithChildren {
	timeout: number;
	onTimeout: () => void;
}

const Timeoutable = ({ timeout, onTimeout, children }: TimeoutableProps) => {
	const timeoutRef = useRef<number | null>(null);

	useEffect(() => {
		if (!timeoutRef.current) {
			timeoutRef.current = setTimeout(() => {
				onTimeout();
			}, timeout);
		}

		return () => clearTimeout(timeoutRef.current || undefined);
	}, [timeout, onTimeout]);

	return <>{children}</>;
};

export default Timeoutable;
